import { useCallback, useState } from 'react';

export type SaveStatus = 'idle' | 'saved' | 'error';

export function useSettingsSectionSave() {
  const [saving, setSaving] = useState(false);
  const [saveStatus, setSaveStatus] = useState<SaveStatus>('idle');

  const runSave = useCallback(async (saveFn: () => Promise<void>) => {
    setSaving(true);
    setSaveStatus('idle');
    try {
      await saveFn();
      setSaveStatus('saved');
      window.setTimeout(() => setSaveStatus('idle'), 2500);
    } catch (err) {
      console.error('[Settings] Save failed:', err);
      setSaveStatus('error');
    } finally {
      setSaving(false);
    }
  }, []);

  const resetStatus = useCallback(() => setSaveStatus('idle'), []);

  return { saving, saveStatus, runSave, resetStatus, setSaveStatus };
}
